const Stocks = 
[
  {
    "ticker": "NASDAQ:ADBE",
    "company": "Adobe Inc."
  },
  {
    "ticker": "NASDAQ:GOOG",
    "company": "Alphabet Inc."
  },
  {
    "ticker": "NASDAQ:GOOGL",
    "company": "Alphabet Inc."
  },
  {
    "ticker": "NASDAQ:AMZN",
    "company": "Amazon.com, Inc."
  },
  {
    "ticker": "NASDAQ:AMGN",
    "company": "Amgen Inc."
  },
  {
    "ticker": "NASDAQ:AAPL",
    "company": "Apple Inc."
  },
  {
    "ticker": "NASDAQ:BIIB",
    "company": "Biogen Inc."
  },
  {
    "ticker": "NASDAQ:BKNG",
    "company": "Booking Holdings Inc."
  },
  {
    "ticker": "NASDAQ:COST",
    "company": "Costco Wholesale Corporation"
  },
  {
    "ticker": "NASDAQ:FB",
    "company": "Facebook, Inc."
  },
  {
    "ticker": "NASDAQ:INTC",
    "company": "Intel Corporation"
  },
  {
    "ticker": "NASDAQ:MSFT",
    "company": "Microsoft Corporation"
  },
  {
    "ticker": "NASDAQ:NFLX",
    "company": "Netflix, Inc."
  },
  {
    "ticker": "NASDAQ:TXN",
    "company": "Texas Instruments Incorporated"
  },
  {
    "ticker": "NASDAQ:KHC",
    "company": "The Kraft Heinz Company"
  },
  {
    "ticker": "NASDAQ:WBA",
    "company": "Walgreens Boots Alliance, Inc."
  },
  {
    "ticker": "NYSE:MMM",
    "company": "3M Company"
  },
  {
    "ticker": "NYSE:ABT",
    "company": "Abbott Laboratories"
  },
  {
    "ticker": "NYSE:ABBV",
    "company": "AbbVie Inc."
  },
  {
    "ticker": "NYSE:ACN",
    "company": "Accenture plc"
  },
  {
    "ticker": "NYSE:AGN",
    "company": "Allergan plc."
  },
  {
    "ticker": "NYSE:ALL",
    "company": "Allstate Corporation (The)"
  },
  {
    "ticker": "NYSE:AXP",
    "company": "American Express Company"
  },
  {
    "ticker": "NYSE:AIG",
    "company": "American International Group, Inc."
  },
  {
    "ticker": "NYSE:T",
    "company": "AT&T Inc."
  },
  {
    "ticker": "NYSE:BAC",
    "company": "Bank of America Corporation"
  },
  {
    "ticker": "NYSE:BK",
    "company": "Bank Of New York Mellon Corporation (The)"
  },
  {
    "ticker": "NYSE:BLK",
    "company": "BlackRock, Inc."
  },
  {
    "ticker": "NYSE:BA",
    "company": "Boeing Company (The)"
  },
  {
    "ticker": "NYSE:CAT",
    "company": "Caterpillar, Inc."
  },
  {
    "ticker": "NYSE:KO",
    "company": "Coca-Cola Company (The)"
  },
  {
    "ticker": "NYSE:CVS",
    "company": "CVS Health Corporation"
  },
  {
    "ticker": "NYSE:XOM",
    "company": "Exxon Mobil Corporation"
  },
  {
    "ticker": "NYSE:F",
    "company": "Ford Motor Company"
  },
  {
    "ticker": "NYSE:GE",
    "company": "General Electric Company"
  },
  {
    "ticker": "NYSE:GS",
    "company": "Goldman Sachs Group, Inc. (The)"
  },
  {
    "ticker": "NYSE:HD",
    "company": "Home Depot, Inc. (The)"
  },
  {
    "ticker": "NYSE:MCD",
    "company": "McDonald&#39;s Corporation"
  },
  {
    "ticker": "NYSE:NKE",
    "company": "Nike, Inc."
  },
  {
    "ticker": "NYSE:ORCL",
    "company": "Oracle Corporation"
  },
  {
    "ticker": "NYSE:PG",
    "company": "Procter & Gamble Company (The)"
  },
  {
    "ticker": "NYSE:RTN",
    "company": "Raytheon Company"
  },
  {
    "ticker": "NYSE:USB",
    "company": "U.S. Bancorp"
  },
  {
    "ticker": "NYSE:UPS",
    "company": "United Parcel Service, Inc."
  },
  {
    "ticker": "NYSE:UTX",
    "company": "United Technologies Corporation"
  },
  {
    "ticker": "NYSE:VZ",
    "company": "Verizon Communications Inc."
  },
  {
    "ticker": "NYSE:V",
    "company": "Visa Inc."
  },
  {
    "ticker": "NYSE:WMT",
    "company": "Walmart Inc."
  },
  {
    "ticker": "NYSE:DIS",
    "company": "Walt Disney Company (The)"
  },
  {
    "ticker": "NYSE:WFC",
    "company": "Wells Fargo & Company"
  },
  {
    "ticker": "KRX:005380",
    "company": "Hyundai Motor"
  },
  {
    "ticker": "KRX:005930",
    "company": "Samsung Electronics Co., Ltd"
  },
  {
    "ticker": "KRX:023530",
    "company": "Lotte Shopping"
  },
  {
    "ticker": "KRX:000270",
    "company": "KIA Motors"
  },
  {
    "ticker": "KRX:066570",
    "company": "LG Electronics"
  }
];

export default Stocks;


// WEBPACK FOOTER //
// ./src/routes/Dashboard/Stocks.tsx